import { layout } from '@citrite/web-ui-component';
import styled from '@emotion/styled';

export const FlexRow = styled.div<{
	gap?: 'small' | 'medium' | 'large';
	align?: 'flex-start' | 'center' | 'flex-end';
}>`
	display: flex;
	align-items: ${props => props.align || 'center'};
	gap: ${props => {
		switch (props.gap) {
			case 'small':
				return layout.smallSpace;
			case 'large':
				return layout.largeSpace;
			default:
				return layout.mediumSpace;
		}
	}};
`;
